import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      background: palette.background.underBox,
      borderRadius: palette.borderRadius.default,
      fontWeight: 400,
      color: palette.title.primary,
      padding: '10px',
      fontSize: '0.875rem',
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      gap: '10px'
    },
    title: {
      fontWeight: 600,
      color: palette.text.lighter,
      opacity: '0.5',
      margin: '0'
    },
    text: {
      margin: '0'
    },
    link: {
      width: 'fit-content',
      margin: 'auto'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
